import { Component, OnInit, Input } from '@angular/core';
import { ElementRow } from '../treelist.model';
import { TreelistEventService } from '../treelist-event.service';
import { TreelistRest } from '../treelist.rest';

@Component({
  selector: '[app-treelist-element]',
  templateUrl: './treelist-element.component.html',
  styleUrls: ['./treelist-element.component.css']
})
export class TreelistElementComponent implements OnInit {

  @Input() elements: ElementRow[] = [];
  @Input() apiPath: string;
 

  constructor(
    private eventsService: TreelistEventService,
    private rest: TreelistRest
  ) { }

  ngOnInit() {

  }

  private toggleElements(element: ElementRow){
    if(!element.elements || element.elements.length === 0){      
      if(element.hasChildren)
      {
        //get children form rest api
        let elementId: any;
        if(element.guid){
          elementId = element.guid;
        }
        else{
          elementId = element.id;
        }
        this.rest.getElementChildren(this.apiPath, elementId).subscribe(data => element.elements = data);
      }      
    }
    element.isExpanded = !element.isExpanded;
  }

  private selectElement(element: ElementRow){
    if(!element.isSelected){
      this.eventsService.announceSelect(element);
    }
  }
}
